module.exports = __webpack_public_path__ + "img/NKcropwise.43474c78.png";